import {createSelector} from "@reduxjs/toolkit";
import AuditEditState from "../types/AuditEditState";
import {State} from "../../../store";
import useSelector from "../../common/hooks/useSelector";

export default function useAuditEditSelector<TSelected>(selector: (state: AuditEditState) => TSelected, equalityFn?: (left: TSelected, right: TSelected) => boolean): TSelected {
    const reselect = createSelector((state: State) => state.auditEdit, selector);
    return useSelector(reselect, equalityFn);
}